import { useTranslation } from 'gatsby-plugin-react-i18next'
import { graphql, useStaticQuery } from 'gatsby';
import { getImage } from 'gatsby-plugin-image';

import { ResultsMapper } from '../SellingHero/SearchInput';
import Link from '../Atoms/Link';
import { ImageGatsby } from '../Atoms/Image';

import useSearch from '../../utils/hooks/useSearch';

import ArrowButton from '../Atoms/ArrowButton';
import Trust from '../Atoms/Icons/Trust';
import { useState } from 'react';
import { SELLING_SEARCH_ROUTE } from '../../utils/routes/const';

const imageQuery = graphql`
query {
  referenceSearch: file(base: {eq: "reference-search.jpg"}) {
    childImageSharp {
      gatsbyImageData(
        width: 564,
        placeholder: DOMINANT_COLOR
      )
    }
  }
}
`;

const ReferenceSearch = ({ hasImage = true }: { hasImage: boolean }) => {
  const { t } = useTranslation();
  const [isFocused, setIsFocused] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const { referenceSearch } = useStaticQuery(imageQuery);

  const { data, isLoading } = useSearch(searchQuery, isFocused, { limit: 3, searchLimitting: true });

  return (
    <section className="md:p-16 flex justify-end pt-24 pb-10 lg:pb-44 bg-gray">
      <div className="max-w-screen-2xl w-full mx-auto relative">
        {hasImage && <Trust className="hidden lg:block mb-2" />}
        <div className="flex flex-col-reverse xl:flex-row relative md:ml-auto mx-auto px-4">
          {hasImage && (
            <div className="w-3/4 lg:w-auto xl:absolute left-32 bottom-16 -mt-16 lg:mt-0 lg:mx-auto xl:mx-0">
              <ImageGatsby
                width="100%"
                image={getImage(referenceSearch)}
                alt="reference search image" />
            </div>
          )}
          <div className={`border-primary border pb-20 lg:pb-8 xl:pb-24 p-4 lg:p-8 xl:p-24 ${hasImage ? 'xl:pl-80 xl:w-2/3' : ''} ml-auto flex flex-col`}>
            <p className="font-cirka text-xl pb-4">{t('referenceSearch.subTitle')}</p>
            <h2 className="text-primary font-cirka text-4xl lg:text-5.5xl pb-12 leading-none">{t('referenceSearch.title')}</h2>
            <p className="text-lg order-3" dangerouslySetInnerHTML={{ __html: t('referenceSearch.searchHint') }} />
            <form action={SELLING_SEARCH_ROUTE} className="pt-8 pb-4 flex flex-col order-4 relative" autoComplete='off'>
              <div className="flex">
                <input
                  type="text"
                  name="q"
                  placeholder={t('referenceSearch.placeholder')}
                  className="text-primary border-primary border placeholder-primary py-2 lg:py-4 px-3 lg:px-5 mr-5 font-roboto w-5/6 bg-transparent"
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchQuery(e.target.value)}
                />
                <button type="submit">
                  <ArrowButton isGhost={false} />
                </button>
              </div>
              {/* disabled for now */}
              {searchQuery && false &&
                (<div style={{ filter: 'drop-shadow(8px 12px 30px rgba(163, 141, 112, 0.267455))' }}>
                  <ResultsMapper data={data} isLoading={isLoading} />
                </div>)
              }
            </form>
            <p className="order-5 font-bold">{t('referenceSearch.noResultHint')}<Link className="text-primary font-bold" to='/'>{t('referenceSearch.linkToFaq')}</Link></p>
          </div>
        </div>
      </div>

    </section>
  )
}

export default ReferenceSearch
